import { Anchor, Badge, Box, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconChartLine, IconHistory } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import WebhooksStats from './WebhooksStats';

const WebhooksCards = ({ webhooks, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const domainCurrency = currentDomain.currency;
  const location = useLocation();

  return webhooks.map((webhook) => (
    <Card key={webhook.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Anchor href={`#${location.pathname}/${webhook.id}/details`} fw={600}>
              {webhook.name}
            </Anchor>
            <Box>
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(webhook.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(webhook.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${webhook.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <WebhooksStats stats={stats} webhook={webhook} period={period} currency={domainCurrency} />
      </Card.Section>
    </Card>
  ));
};

export default WebhooksCards;
